import React from 'react'
import PropTypes from 'prop-types'
import { intlMessageShape } from 'sb-react-intl'
import cx from 'classnames'

import Message from 'components/text/Message/Message'

import messages from './messages'
import s from './ButtonContent.scss'


const ButtonContent = ({ children, title, size, loading, centering, noPadding }) => {
  const className = cx(s[size], {
    [s.center]: centering,
    [s.noPadding]: noPadding,
  })

  if (loading) {
    return <Message className={className} text={messages.loading} />
  }

  if (title) {
    return <Message className={className} text={title} />
  }

  return <div className={className}>{children}</div>
}

ButtonContent.propTypes = {
  children: PropTypes.any,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(intlMessageShape),
  ]),
  size: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  centering: PropTypes.bool,
  noPadding: PropTypes.bool,
}


export default ButtonContent
